<div [class.show]="isLoading" class="loading-overlay">
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
</div>
